import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { EachWayPlaceTerms } from '@swf/sports/components';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';
import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';

import SelectionList from '../../components/SelectionList/SelectionList';

import styles from './AntePostList.scss';

const AntePostList: MarketTemplateComponent<
  SingleMarketTemplateProps & {
    showPreviousPrice?: true;
  }
> = ({ marketId, showPreviousPrice }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const market = useSelector((state: RootState) => widgetSelect.market(state, marketId));
  const { runners = [], placeTerms } = market ?? {};

  if (!market) return null;
  return (
    <SelectionList
      as="dl"
      data-testid="market-template-ante-post-list"
      className={styles.wrapper}
      market={market}
    >
      {placeTerms ? (
        <SelectionList.Title data-testid="market-template-ante-post-list-title">
          <EachWayPlaceTerms placeTerms={placeTerms} className={styles.eachWay} />
        </SelectionList.Title>
      ) : null}
      {runners.map((runner) => (
        <SelectionList.Item
          key={runner.selectionId}
          runner={runner}
          showPreviousPrice={showPreviousPrice}
        />
      ))}
    </SelectionList>
  );
};

AntePostList.marketTemplateType = 'BASE';

export default AntePostList;
